class FetchStatus {
  private updateSessionInProgress: boolean;
  public latestUpdateSessionTimeStamp: number;

  constructor() {
    // conveys re-auth in progress for all auth types
    this.updateSessionInProgress = false;
    // timestamp of last successful update session call
    this.latestUpdateSessionTimeStamp = Date.now();
  }

  getUpdateSessionStatus = () => {
    return this.updateSessionInProgress;
  };

  setUpdateSessionStatus = (val: boolean) => {
    this.updateSessionInProgress = val;
  };
}

export default FetchStatus;
